import React from 'react';
import {Button, Select, Tag} from "antd";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminProductsDelivery, useApiSearchAdminProductsDeliveryStepLesson} from "@/api/product";
import {URLS} from "@/lib/urls";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {CheckCircleOutlined, ClockCircleOutlined, ExclamationCircleOutlined, PrinterOutlined} from "@ant-design/icons";

function ProductDeliverLessonsList({id}) {

    const statusMap = {
        pending: {label: 'در انتظار', color: 'gold', icon: <ClockCircleOutlined/>},
        print: {label: 'چاپ رسید', color: 'blue', icon: <PrinterOutlined/>},
        delivered: {label: 'تحویل شده', color: 'green', icon: <CheckCircleOutlined/>},
        refund: {label: 'مرجوع شده', color: 'red', icon: <ExclamationCircleOutlined/>},
    };

    const columns = [
        {
            title: 'کد تحویل مربی',
            dataIndex: 'code',
            key: 'code',
            width: 140,
            responsive: ['md'],
            render: (text) => (
                <span className="font-medium">
                {text}
            </span>
            ),
        },

        {
            title: 'سرفصل / توضیحات',
            dataIndex: ['lesson', 'title'],
            key: 'lesson',
            responsive: ['md'],
            render: (_, record) => (
                <div className="flex flex-col gap-1 max-w-xl">
                    <div className="flex gap-1">
                        <span>
                            <Tag>{record?.lesson?.code}</Tag>
                        </span>
                        <span className="font-medium">
                            {record?.lesson?.title || '-'}
                        </span>
                    </div>


                    {record?.lesson?.topic?.title && (
                        <span className="text-xs   dark: ">
                        {record.lesson.topic.title}
                    </span>
                    )}
                </div>
            ),
        },

        {
            title: 'مربی',
            key: 'teacher',
            width: 180,
            responsive: ['md'],
            render: (_, record) => (
                <div className="flex flex-col gap-1">
                <span>
                    {record?.lesson?.teacher_detail?.firstname}{' '}
                    {record?.lesson?.teacher_detail?.lastname}
                </span>

                    {record?.lesson?.teacher_detail?.mobile && (
                        <span className="text-xs   dark: ">
                        {record.lesson.teacher_detail.mobile}
                    </span>
                    )}
                </div>
            ),
        },

        {
            title: 'جنسیت',
            key: 'gender',
            width: 100,
            align: 'center',
            responsive: ['md'],
            render: (_, record) => {
                const gender = record?.lesson?.gender;

                return gender === 'female' ? 'دختر' : 'پسر';
            },
        },

        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            width: 120,
            align: 'center',
            responsive: ['md'],
            render: (status) => (
                <Tag color={statusMap[status].color}>
                    {statusMap[status].label}
                </Tag>
            ),
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            width: 160,
            responsive: ['md'],
            render: (text) =>
                text
                    ? convertToJalaliWithFormat(
                        text,
                        'jYYYY/jMM/jDD HH:mm:ss'
                    )
                    : '-',
        },


        // Mobile
        {
            title: '',
            key: 'mobile',
            responsive: ['xs', 'sm'],
            render: (_, record) => {
                const teacher = record?.lesson?.teacher_detail;
                const gender = record?.lesson?.gender;

                return (
                    <div className="flex md:hidden flex-col gap-4 py-1">

                        {/* کد */}
                        <div className="flex items-center justify-between gap-3">
                        <span className="text-xs   dark: ">
                            کد
                        </span>

                            <span className="text-sm font-medium text-black dark:text-white">
                            {record?.code || '-'}
                        </span>
                        </div>

                        {/* درس / محل برگزاری */}
                        <div className="flex flex-col gap-1">
                        <span className="text-xs   dark: ">
                            درس / محل برگزاری
                        </span>

                            <span className="text-sm font-medium text-black dark:text-white">
                            {record?.lesson?.title || '-'}
                        </span>

                            {record?.lesson?.topic?.title && (
                                <span className="text-xs   dark: ">
                                {record.lesson.topic.title}
                            </span>
                            )}
                        </div>

                        {/* مدرس */}
                        <div className="flex items-center justify-between gap-3">
                        <span className="text-xs   dark: ">
                            مدرس
                        </span>

                            <div className="flex flex-col items-end">
                            <span className="text-sm text-black dark:text-white">
                                {teacher?.firstname}{' '}
                                {teacher?.lastname}
                            </span>

                                {teacher?.mobile && (
                                    <span className="text-xs   dark: ">
                                    {teacher.mobile}
                                </span>
                                )}
                            </div>
                        </div>

                        {/* جنسیت */}
                        <div className="flex items-center justify-between gap-3">
                        <span className="text-xs   dark: ">
                            جنسیت
                        </span>

                            <span className="text-sm text-black dark:text-white">
                            {gender === 'female' ? 'دختر' : 'پسر'}
                        </span>
                        </div>

                        {/* وضعیت */}
                        <div className="flex items-center justify-between gap-3">
                        <span className="text-xs   dark: ">
                            وضعیت
                        </span>

                            <Tag color={record?.status === 'pending' ? 'orange' : 'green'}>
                                {record?.status === 'pending'
                                    ? 'در انتظار'
                                    : record?.status || '-'}
                            </Tag>
                        </div>

                        {/* تاریخ ثبت */}
                        <div className="flex items-center justify-between gap-3">
                        <span className="text-xs   dark: ">
                            تاریخ ثبت
                        </span>

                            <span className="text-sm text-black dark:text-white">
                            {record?.created_at
                                ? convertToJalaliWithFormat(
                                    record.created_at,
                                    'jYYYY/jMM/jDD HH:mm:ss'
                                )
                                : '-'}
                        </span>
                        </div>


                    </div>
                );
            },
        },
    ];
    return (
        <div>

            <TableSearch

                searchInput={true}

                apiFn={useApiSearchAdminProductsDeliveryStepLesson}
                fnArgs={{
                    id: id
                }}
                columns={columns}

                responsive={true}
                rowKey="id"
            />

        </div>
    );
}

export default ProductDeliverLessonsList;